import axios from 'axios';

const CouponsAPI = {
  getUserCoupons(params = {}) {
    return axios.get('/user-coupons', { params }).then((response) => {
      return response.data;
    });
  },

  createUserCoupon(data) {
    return axios.post('/user-coupons', data);
  },
};

export default CouponsAPI;
